/**
 * Track an event in Heap
 * 
 * @param eventName - The name of the event to track
 * @param properties - Additional properties to include with the event
 */
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  try {
    // Check if window and heap exist
    if (typeof window !== 'undefined' && window.heap && typeof window.heap.track === 'function') {
      window.heap.track(eventName, properties);
    } else {
      console.warn('Heap not initialized. Event not tracked:', eventName);
    }
  } catch (error) {
    console.error('Error tracking event in Heap:', error);
  }
};

/**
 * Track page view in Heap
 * 
 * @param pageName - The name of the page being viewed
 * @param properties - Additional properties to include with the event
 */
export const trackPageView = (pageName: string, properties?: Record<string, any>) => {
  trackEvent('Page View', {
    page: pageName,
    ...properties
  });
};

/**
 * Identify a user in Heap
 * 
 * @param userId - The unique identifier for the user
 * @param traits - Additional user properties
 */
export const identifyUser = (userId: string, traits?: Record<string, any>) => {
  try {
    if (typeof window !== 'undefined' && window.heap) {
      if (typeof window.heap.identify === 'function') {
        window.heap.identify(userId);
      }
      
      if (traits && Object.keys(traits).length > 0 && typeof window.heap.addUserProperties === 'function') {
        window.heap.addUserProperties(traits);
      }
    } else {
      console.warn('Heap not initialized. User not identified:', userId);
    }
  } catch (error) {
    console.error('Error identifying user in Heap:', error);
  }
}; 